import { render, staticRenderFns } from "./AgreementsIcon.vue?vue&type=template&id=7d89eaa4"
import script from "./AgreementsIcon.vue?vue&type=script&lang=js"
export * from "./AgreementsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports